import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';

import { environment } from '../../../environments/environment';
import { AppConfigService } from '@services/app-config.service';
import { AuthService } from '@services/auth.service';
import { NavService } from '@services/nav.service';
import { NavLink } from '@classes/nav-link';
import { AuthUser } from '@classes/auth/auth-user';
import { OrdersService } from '@services/orders.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit, OnChanges {
  private subscription = new Subscription();

  @Input() isAuth: boolean;
  @Output() sidenavClose = new EventEmitter<void>();

  navLinks: NavLink[];

  assignedToTreat: number;
  unassignedToTreat: number;

  appVersion: string;
  user: AuthUser;
  isMaintenance: boolean;
  isLocalTranslations: boolean;

  constructor(
    private configSrv: AppConfigService,
    private authSrv: AuthService,
    private navSrv: NavService,
    private ordersSrv: OrdersService
  ) { }

  ngOnInit() {
    this.appVersion = environment.version;
    this.isMaintenance = this.configSrv.isMaintenance;
    this.isLocalTranslations = environment.localTranslations;
  }

  ngOnChanges(): void {
    if (this.isAuth) {
      this.user = this.authSrv.getUser();
      this.navLinks = this.navSrv.getNavLinks();

      this.initSub();

      this.ordersSrv.getCounter().subscribe();

      let interval = setInterval(() => {
        this.ordersSrv.getCounter().subscribe();
      }, 120000)

      this.authSrv.authChanged.subscribe((result) => {
        if (!result) {
          clearInterval(interval);
        }
      })

    } else {
      this.user = null;
      this.navLinks = null;
    }
  }

  initSub() {
    this.subscription.add(
      this.ordersSrv.counterTriggered.subscribe(triggered => {
        if (triggered) {
          this.assignedToTreat = this.ordersSrv.assignedToTreatSubject.getValue();
          this.unassignedToTreat = this.ordersSrv.unassignedToTreatSubject.getValue();

          this.updateBadges();
        }
      })
    )
  }

  updateBadges() {
    this.navLinks.map(navLink => {
      if (navLink.hasBadge) {
        if (navLink.badge === 'assignedToTreat') {
          navLink.badgeNumber = this.assignedToTreat;
        } else if (navLink.badge === 'unassignedToTreat') {
          navLink.badgeNumber = this.unassignedToTreat;
        }
      }
    })
  }

  onCloseSidenav(): void {
    this.sidenavClose.emit();
  }
}
